import { combineReducers } from 'redux';
import channelChannelConfView from './channelChannelConfView';
import chId from './chId';
//
export default combineReducers({
  channelChannelConfView,
  chId,
});
